/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ShiMing.vue?vue&type=template&id=7ba0bf99&scoped=true&"
import script from "./ShiMing.vue?vue&type=script&lang=js&"
export * from "./ShiMing.vue?vue&type=script&lang=js&"
import style0 from "./ShiMing.vue?vue&type=style&index=0&id=7ba0bf99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0bf99",
  null
  
)

export default component.exports